import { createResourceStore } from './createResourceStore';

const useTokensLogStore = createResourceStore({
  endpoint: '/admin/tokens-logs',
  collectionKey: 'tokensLogs',
  itemKey: 'tokensLog',
  paginated: true,
  totalKey: 'totalTokensLogs',
  hasCreate: false,
  hasUpdate: false,
  hasFetchById: true,
  mapListParams: (page = 1, orgId, startDate, endDate) => ({
    page,
    orgId,
    startDate,
    endDate,
  }),
  methods: {
    fetch: 'fetchTokensLogs',
    delete: 'deleteTokensLog',
    fetchById: 'fetchTokensLogById',
  },
});

export default useTokensLogStore;
